export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=An%20artistic%20overhead%20composition%20of%20fashion%20pieces%20arranged%20in%20a%20circular%20pattern%20on%20a%20light%20sand-colored%20linen%20fabric%2C%20including%20a%20folded%20indigo%20denim%20jacket%20a%20cream%20knit%20beanie%20a%20leather%20belt%20coiled%20in%20the%20center%20and%20a%20pair%20of%20round%20sunglasses%2C%20natural%20daylight%20from%20above%20no%20shadows%2C%20flatlay%20editorial%20style%2C%20soft%20tactile%20textures%20visible%20in%20the%20fabric%20weave%20and%20leather%20grain%2C%20calming%20neutral%20palette%20with%20subtle%20indigo%20accent%2C%20minimalist%20lifestyle%20photography%2C%20serene%20and%20balanced%20circular%20arrangement&width=1920&height=900&seq=cta-bg-v2-superbuy-18&orientation=landscape"
          alt="Superbuy Sheet collection"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 via-foreground-900/40 to-foreground-900/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-primary-300 bg-background-50/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <i className="ri-flashlight-line"></i>
          Start Exploring
        </span>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
          Ready to Discover the Best{' '}
          <span className="italic text-primary-300">Superbuy Sheet</span> Finds?
        </h2>
        <p className="text-base text-background-50/70 mb-10 max-w-xl mx-auto leading-relaxed">
          Access thousands of curated products across 14 categories. Your next favorite find is just a click away.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 bg-primary-500 text-background-50 px-10 py-5 rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap group shadow-lg shadow-primary-500/25"
          >
            <span className="w-8 h-8 rounded-full bg-background-50/20 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line text-background-50 text-sm"></i>
            </span>
            Explore Superbuy Sheet
            <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 border-2 border-background-50/30 text-background-50 px-8 py-5 rounded-full font-semibold text-sm hover:bg-background-50/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}